/**
 * This file will have to be replaced once Nacre's new version is
 * implemented in Carnage
 */

const leftpad = (color) => `00${color}`.slice(-2);

/**
 * Represents a RGB-defined color
 */
export default class Color {
    constructor(red = 0, green = 0, blue = 0) {
        this.red = red < 0 ? 0 : red;
        this.green = green < 0 ? 0 : green;
        this.blue = blue < 0 ? 0 : blue;
    }

    /**
   * Darkens the current color
   * @returns { Color } New darkened color object
   */
    darken(by = Color.DARKEN) {
        let { red, green, blue } = this;
        return new Color(
            Color.substraction(red, by),
            Color.substraction(green, by),
            Color.substraction(blue, by),
        );
    }

    /**
   * Lighten the current color
   * @returns { Color } New lighten color object
   */
    lighten(by = Color.DARKEN) {
        let { red, green, blue } = this;

        return new Color(
            Color.addition(red, by),
            Color.addition(green, by),
            Color.addition(blue, by),
        );
    }

    static addition(color, shade) {
        if (color + shade > 255) {
            return 255;
        }
        return color + shade;
    }

    static substraction(color, shade) {
        if (color - shade < 0) {
            return 0;
        }
        return color - shade;
    }

    /**
   * Returns a HEX representation of this color
   * @returns {string} Hex color appended with '#'
   */
    toString() {
        let { red, green, blue } = this;
        return `#${leftpad(red.toString(16))}${leftpad(green.toString(16))}${leftpad(blue.toString(16))}`;
    }

    /**
   * Creates a new color object from a hex representation
   * @param {string} rgb - Hex color, example: #EB45F4
   * @returns { Color } New color object
   */
    static fromString(rgb) {
        let [r1, r2, g1, g2, b1, b2] = rgb.replace('#', '').split('');
        let red = parseInt(`${r1}${r2}`, 16);
        let green = parseInt(`${g1}${g2}`, 16);
        let blue = parseInt(`${b1}${b2}`, 16);
        return new Color(red, green, blue);
    }
}

Color.DARKEN = 20;
